<template>
  <div
    id="experience-wrapper--main-maps"
    class="experience-wrapper--section-map"
  >
    <template v-if="hasDescription">
      <LazyHydrate never>
        <el-container>
          <section class="experience-wrapper--section-map-description">
            <h2>{{ $t(`${base}.title`, { location: startingPoint }) }}</h2>
            <p>{{ exMap.description }}</p>
          </section>
        </el-container>
      </LazyHydrate>
    </template>

    <div :class="isPpcv1 && isMobile ? 'ppcv1' : 'lad-wrapper-map'">
      <LadMapImages
        :height="isMobile && isPpcv1 ? '350px' : '600px'"
        :center="mapData.center"
        :zoom="mapData.zoom"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LadSectionMap',
  components: {
    LadMapImages: () =>
      import(
        /* webpackChunkName: "lad-map-images" */ '@/components/frontends/mapbox/images'
      ),
  },
  data() {
    return {
      base: 'experience.map',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    isPpcv1() {
      return this.$route.params.test === 'ppcv1'
    },
    ...mapState('experience', {
      exMap: 'map',
      startingPoint: (state) => state.experience.starting_point,
    }),
    hasDescription() {
      return this.exMap.description.trim().split(' ').length > 2
    },
    mapData() {
      const lat = this.exMap.lat
      const lng = this.exMap.lng

      return {
        center: `${lng},${lat}`,
        zoom: this.exMap.zoom,
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--section-map {
  margin: 0;
  position: relative;

  &-description {
    padding: 2em 2em 3em !important;
    background-color: white !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
    width: 40%;
    max-width: 500px;
    position: absolute;
    z-index: 10;
    top: 10%;
  }

  .lad-wrapper-map {
    min-height: 600px;
  }

  .ppcv1 {
    max-height: 350px;
  }

  @media screen and (max-width: 700px) {
    margin: 0;

    &-description {
      padding: 2em !important;
      width: inherit;
      max-width: inherit;
      position: relative;
      top: inherit;
      margin-bottom: 20px;
    }
  }
}
</style>
